module.exports = __webpack_public_path__ + "fonts/Lato-Bold.d878b6c2.woff";